<template>
  <div class="container-fluid">
    <span class="bold">Total alkoholsalg</span><br/>
    <table class="xz-table">
      <thead>
      <tr>
        <th class="bold"></th>
        <th class="bold">MVA%</th>
        <th class="bold">MVA</th>
        <th class="bold">Netto</th>
        <th class="bold">Brutto</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Alkoholdrikker</td>
        <td>{{vat.dineIn}}%</td>
        <td>{{ displayTwoDecimals(totalAlcoholDrinksDineInVat) }}</td>
        <td>{{ displayTwoDecimals(totalAlcoholDrinksDineInNetto )}}</td>
        <td>{{ displayTwoDecimals(totalAlcoholDrinksDineInBrutto) }}</td>
      </tr>
      <tr>
        <td class="bold">Total</td>
        <td class="bold"></td>
        <td class="bold">{{ displayTwoDecimals(totalAlcoholDrinksDineInVat) }}</td>
        <td class="bold">{{ displayTwoDecimals(totalAlcoholDrinksDineInNetto) }}</td>
        <td class="bold">{{ displayTwoDecimals(totalAlcoholDrinksDineInBrutto) }}</td>
      </tr>
      </tbody>
    </table>
    <hr class="horizontal-dashed"/>
  </div>
</template>

<script>
import MathUtil from "@/util/MathUtil";

export default {
  props: {
    zReports: Array,
    vat: Object
  },
  computed: {
    totalAlcoholDrinksDineInVat() {
      let alcoholDrinksDineInVat = (this.totalAlcoholDrinksDineInBrutto / (100 + this.vat.dineIn)) * this.vat.dineIn;
      return MathUtil.roundTwoDecimals(alcoholDrinksDineInVat);
    },
    totalAlcoholDrinksDineInBrutto() {
      var alcoholDrinksDineInBrutto = 0;
      for (let x = 0; x < this.zReports.length; x++) {
        var zReport = this.zReports[x].cagistahospitality;
        for (let i = 0; i < zReport.categories.length; i++) {
          const category = zReport.categories[i];
          if(category.itemType == 'DRINK_ALCOHOL' && category.vatRate == this.vat.dineIn){
            alcoholDrinksDineInBrutto = alcoholDrinksDineInBrutto + category.amountWithVat;
          }
        }
      }
      return MathUtil.roundTwoDecimals(alcoholDrinksDineInBrutto);
    },
    totalAlcoholDrinksDineInNetto() {
      return (this.totalAlcoholDrinksDineInBrutto - this.totalAlcoholDrinksDineInVat);
    }
  },
  methods:{
    displayTwoDecimals(num){
      if(num > 0 || num < 0){
        return MathUtil.displayTwoDecimals(num);
      }else {
        return num;
      }
    }
  }
}
</script>